module.exports = __webpack_public_path__ + "static/media/mountains-small.4a853639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mountains-small.jpg
// module id = 93
// module chunks = 3